export const svgMP3 = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z"
      fill="#E2E8F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 1.52588e-05V4H22L18 1.52588e-05Z"
      fill="#94A3B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 8V4H18L22 8Z"
      fill="#CBD5E1"
    />
    <rect x="1" y="10" width="22" height="10" rx="1" fill="#14B8A6" />
    <path
      d="M3.85938 18H4.76953V13.9922H4.83594L6.39844 18H7.08594L8.64844 13.9922H8.71875V18H9.625V12.3633H8.46875L6.77734 16.6992H6.71094L5.01562 12.3633H3.85938V18ZM11.0156 18H12.0234V16.1367H13.2656C14.4102 16.1367 15.1836 15.3789 15.1836 14.2539V14.2461C15.1836 13.1172 14.4102 12.3633 13.2656 12.3633H11.0156V18ZM13.0195 13.1875C13.7422 13.1875 14.1641 13.5742 14.1641 14.25V14.2578C14.1641 14.9336 13.7422 15.3242 13.0195 15.3242H12.0234V13.1875H13.0195ZM18.2305 18.1133C19.4805 18.1133 20.3359 17.4219 20.3359 16.4297V16.4219C20.3359 15.6406 19.7852 15.1484 18.957 15.0703V15.0508C19.6328 14.9102 20.1367 14.4453 20.1367 13.7461V13.7383C20.1367 12.8555 19.3828 12.25 18.2227 12.25C17.0859 12.25 16.3164 12.8906 16.2305 13.8672L16.2266 13.9102H17.1641L17.168 13.8711C17.2188 13.3672 17.6289 13.0508 18.2227 13.0508C18.8242 13.0508 19.1719 13.3555 19.1719 13.8711V13.8789C19.1719 14.3711 18.7578 14.7227 18.1367 14.7227H17.4922V15.4727H18.1562C18.8789 15.4727 19.3164 15.8008 19.3164 16.3945V16.4023C19.3164 16.9258 18.8828 17.2891 18.2305 17.2891C17.5703 17.2891 17.1289 16.9492 17.0742 16.4727L17.0703 16.4297H16.1094L16.1133 16.4766C16.1875 17.4414 16.9961 18.1133 18.2305 18.1133Z"
      fill="white"
    />
  </svg>
);
export const svgPNG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z"
      fill="#E2E8F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 1.52588e-05V4H22L18 1.52588e-05Z"
      fill="#94A3B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 8V4H18L22 8Z"
      fill="#CBD5E1"
    />
    <rect x="1" y="10" width="22" height="10" rx="1" fill="#3B82F6" />
    <path
      d="M3.99609 18H5.00391V16.1367H6.24609C7.39062 16.1367 8.16406 15.3789 8.16406 14.2539V14.2461C8.16406 13.1172 7.39062 12.3633 6.24609 12.3633H3.99609V18ZM6 13.1875C6.72266 13.1875 7.14453 13.5742 7.14453 14.25V14.2578C7.14453 14.9336 6.72266 15.3242 6 15.3242H5.00391V13.1875H6ZM9.27734 18H10.25V14.1172H10.3125L13.082 18H13.9531V12.3633H12.9844V16.2461H12.9219L10.1523 12.3633H9.27734V18ZM17.7578 18.1406C19.2617 18.1406 20.2227 17.207 20.2227 15.75V15.0469H17.8828V15.8164H19.2344L19.2305 15.9336C19.2188 16.7344 18.6328 17.2695 17.7734 17.2695C16.7695 17.2695 16.1367 16.4688 16.1367 15.1758V15.168C16.1367 13.8945 16.7578 13.0938 17.7422 13.0938C18.4648 13.0938 18.9805 13.4531 19.1641 14.0703L19.1758 14.1094H20.1758L20.1719 14.0703C19.9805 12.9688 19.043 12.2227 17.7422 12.2227C16.1367 12.2227 15.1094 13.375 15.1094 15.1758V15.1836C15.1094 17.0039 16.125 18.1406 17.7578 18.1406Z"
      fill="white"
    />
  </svg>
);
export const svgJPG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z"
      fill="#E2E8F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 1.52588e-05V4H22L18 1.52588e-05Z"
      fill="#94A3B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 8V4H18L22 8Z"
      fill="#CBD5E1"
    />
    <rect x="1" y="10" width="22" height="10" rx="1" fill="#A855F7" />
    <path
      d="M6.12109 18.1406C7.27734 18.1406 7.95312 17.4688 7.95312 16.3281V12.3633H6.94531V16.3203C6.94531 16.9297 6.65625 17.2578 6.11328 17.2578C5.61328 17.2578 5.34766 16.9336 5.32031 16.5L5.31641 16.4727H4.33203L4.33594 16.5156C4.375 17.4805 5.02734 18.1406 6.12109 18.1406ZM9.34375 18H10.3516V16.1367H11.5938C12.7383 16.1367 13.5117 15.3789 13.5117 14.2539V14.2461C13.5117 13.1172 12.7383 12.3633 11.5938 12.3633H9.34375V18ZM11.3477 13.1875C12.0703 13.1875 12.4922 13.5742 12.4922 14.25V14.2578C12.4922 14.9336 12.0703 15.3242 11.3477 15.3242H10.3516V13.1875H11.3477ZM17.0352 18.1406C18.5391 18.1406 19.5 17.207 19.5 15.75V15.0469H17.1602V15.8164H18.5117L18.5078 15.9336C18.4961 16.7344 17.9102 17.2695 17.0508 17.2695C16.0469 17.2695 15.4141 16.4688 15.4141 15.1758V15.168C15.4141 13.8945 16.0352 13.0938 17.0195 13.0938C17.7422 13.0938 18.2578 13.4531 18.4414 14.0703L18.4531 14.1094H19.4531L19.4492 14.0703C19.2578 12.9688 18.3203 12.2227 17.0195 12.2227C15.4141 12.2227 14.3867 13.375 14.3867 15.1758V15.1836C14.3867 17.0039 15.4023 18.1406 17.0352 18.1406Z"
      fill="white"
    />
  </svg>
);
export const svgGIF = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z"
      fill="#E2E8F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 1.52588e-05V4H22L18 1.52588e-05Z"
      fill="#94A3B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 8V4H18L22 8Z"
      fill="#CBD5E1"
    />
    <rect x="1" y="10" width="22" height="10" rx="1" fill="#F59E0B" />
    <path
      d="M8.52734 18.1406C10.0312 18.1406 10.9922 17.207 10.9922 15.75V15.0469H8.65234V15.8164H10.0039L10 15.9336C9.98828 16.7344 9.40234 17.2695 8.54297 17.2695C7.53906 17.2695 6.90625 16.4688 6.90625 15.1758V15.168C6.90625 13.8945 7.52734 13.0938 8.51172 13.0938C9.23438 13.0938 9.75 13.4531 9.93359 14.0703L9.94531 14.1094H10.9453L10.9414 14.0703C10.75 12.9688 9.8125 12.2227 8.51172 12.2227C6.90625 12.2227 5.87891 13.375 5.87891 15.1758V15.1836C5.87891 17.0039 6.89453 18.1406 8.52734 18.1406ZM12.1641 18H13.1719V12.3633H12.1641V18ZM14.5625 18H15.5703V15.6992H17.9336V14.8789H15.5703V13.2109H18.1562V12.3633H14.5625V18Z"
      fill="white"
    />
  </svg>
);
export const svgBlank = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 5C5 3.89543 5.89543 3 7 3H11.75C11.8881 3 12 3.11193 12 3.25V8C12 9.10457 12.8954 10 14 10H18.75C18.8881 10 19 10.1119 19 10.25V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V5Z"
      fill="#E2E8F0"
    />
    <path
      d="M13 8V3.60355C13 3.38083 13.2693 3.26929 13.4268 3.42678L18.5732 8.57322C18.7307 8.73071 18.6192 9 18.3964 9H14C13.4477 9 13 8.55228 13 8Z"
      fill="#222222"
    />
    <path d="M8.5 13.5L14.5 13.5" stroke="#222222" />
    <path d="M8.5 16.5L13.5 16.5" stroke="#222222" />
  </svg>
);
export const svgPDF = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z"
      fill="#E2E8F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 1.52588e-05V4H22L18 1.52588e-05Z"
      fill="#94A3B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 8V4H18L22 8Z"
      fill="#CBD5E1"
    />
    <rect x="1" y="10" width="22" height="10" rx="1" fill="#F43F5E" />
    <path
      d="M4.73828 18H5.74609V16.1367H6.98828C8.13281 16.1367 8.90625 15.3789 8.90625 14.2539V14.2461C8.90625 13.1172 8.13281 12.3633 6.98828 12.3633H4.73828V18ZM6.74219 13.1875C7.46484 13.1875 7.88672 13.5742 7.88672 14.25V14.2578C7.88672 14.9336 7.46484 15.3242 6.74219 15.3242H5.74609V13.1875H6.74219ZM10.0195 18H12.1328C13.8203 18 14.7852 16.9648 14.7852 15.1602V15.1523C14.7852 13.3867 13.8086 12.3633 12.1328 12.3633H10.0195V18ZM11.0273 17.1523V13.2109H12C13.1055 13.2109 13.7578 13.9297 13.7578 15.168V15.1758C13.7578 16.4414 13.1211 17.1523 12 17.1523H11.0273ZM15.9414 18H16.9492V15.6992H19.3125V14.8789H16.9492V13.2109H19.5352V12.3633H15.9414V18Z"
      fill="white"
    />
  </svg>
);
export const svgTXT = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z"
      fill="#E2E8F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 1.52588e-05V4H22L18 1.52588e-05Z"
      fill="#94A3B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 8V4H18L22 8Z"
      fill="#CBD5E1"
    />
    <rect x="1" y="10" width="22" height="10" rx="1" fill="#475569" />
    <path
      d="M6.05078 18H7.05859V13.2109H8.79688V12.3633H4.31641V13.2109H6.05078V18ZM9.5 18H10.6016L11.9336 15.9258H11.9688L13.3008 18H14.4648L12.6094 15.1875V15.1758L14.4961 12.3633H13.3633L12.0586 14.4844H12.0156L10.707 12.3633H9.51562L11.3398 15.1484V15.1602L9.5 18ZM16.9414 18H17.9492V13.2109H19.6875V12.3633H15.207V13.2109H16.9414V18Z"
      fill="white"
    />
  </svg>
);
export const svgXLS = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z"
      fill="#E2E8F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 1.52588e-05V4H22L18 1.52588e-05Z"
      fill="#94A3B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 8V4H18L22 8Z"
      fill="#CBD5E1"
    />
    <rect x="1" y="10" width="22" height="10" rx="1" fill="#10B981" />
    <path
      d="M4.51562 18H5.61719L6.94922 15.9258H6.98438L8.31641 18H9.48047L7.625 15.1875V15.1758L9.51172 12.3633H8.37891L7.07422 14.4844H7.03125L5.72266 12.3633H4.53125L6.35547 15.1484V15.1602L4.51562 18ZM10.5547 18H14.1484V17.1523H11.5625V12.3633H10.5547V18ZM17.1914 18.1406C18.543 18.1406 19.3906 17.4531 19.3906 16.3555V16.3516C19.3906 15.5 18.8945 15.0234 17.707 14.7734L17.1016 14.6445C16.3984 14.4961 16.1133 14.2461 16.1133 13.8477V13.8438C16.1133 13.3633 16.5586 13.0703 17.1836 13.0703C17.8281 13.0664 18.2461 13.3789 18.3164 13.8164L18.3242 13.8633H19.2891L19.2852 13.8125C19.2148 12.9062 18.4375 12.2227 17.1875 12.2227C15.9688 12.2227 15.1016 12.9023 15.1016 13.9102V13.9141C15.1016 14.7539 15.6016 15.293 16.7539 15.5352L17.3594 15.6602C18.0859 15.8164 18.3789 16.0625 18.3789 16.4688V16.4727C18.3789 16.957 17.9023 17.293 17.2227 17.293C16.5078 17.293 16.0039 16.9805 15.957 16.5078L15.9531 16.4688H14.9766L14.9805 16.5234C15.0508 17.4961 15.8828 18.1406 17.1914 18.1406Z"
      fill="white"
    />
  </svg>
);
export const svgMOV = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z"
      fill="#E2E8F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 1.52588e-05V4H22L18 1.52588e-05Z"
      fill="#94A3B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 8V4H18L22 8Z"
      fill="#CBD5E1"
    />
    <rect x="1" y="10" width="22" height="10" rx="1" fill="#6366F1" />
    <path
      d="M3.26953 18H4.17969V13.9922H4.24609L5.80859 18H6.49609L8.05859 13.9922H8.12891V18H9.03516V12.3633H7.87891L6.1875 16.6992H6.12109L4.42578 12.3633H3.26953V18ZM12.8555 18.1406C14.5 18.1406 15.5195 16.9961 15.5195 15.1836V15.1758C15.5195 13.3594 14.4961 12.2227 12.8555 12.2227C11.2188 12.2227 10.1875 13.3594 10.1875 15.1758V15.1836C10.1875 16.9961 11.2031 18.1406 12.8555 18.1406ZM12.8555 17.2695C11.8398 17.2695 11.2148 16.4492 11.2148 15.1836V15.1758C11.2148 13.9023 11.8555 13.0938 12.8555 13.0938C13.8555 13.0938 14.4922 13.9023 14.4922 15.1758V15.1836C14.4922 16.4492 13.8594 17.2695 12.8555 17.2695ZM18.0195 18H19.1992L21.1484 12.3633H20.0352L18.6406 16.8359H18.5742L17.1797 12.3633H16.0703L18.0195 18Z"
      fill="white"
    />
  </svg>
);

export const svgEML = (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 0C1.89543 0 1 0.89543 1 2V22C1 23.1046 1.89543 24 3 24H19C20.1046 24 21 23.1046 21 22V0H3ZM21 0V4L17 1.53859e-05L21 0Z"
      fill="#E2E8F0"
    />
    <path d="M17 1.52588e-05V4H21L17 1.52588e-05Z" fill="#94A3B8" />
    <path d="M21 8V4H17L21 8Z" fill="#CBD5E1" />
    <path
      d="M21 10H1C0.447715 10 0 10.4477 0 11V19C0 19.5523 0.447715 20 1 20H21C21.5523 20 22 19.5523 22 19V11C22 10.4477 21.5523 10 21 10Z"
      fill="#F18963"
    />
    <path
      d="M2.61841 18V11.9155H7.12988V12.9448H3.84692V14.2937H6.90161V15.3188H3.84692V16.9749H7.24609V18H2.61841ZM8.27124 18V11.9155H10.1099L11.2139 16.0659L12.3054 11.9155H14.1482V18H13.0068V13.2104L11.7991 18H10.6162L9.4126 13.2104V18H8.27124ZM15.4016 18V11.9653H16.6301V16.9749H19.6848V18H15.4016Z"
      fill="white"
    />
  </svg>
);

export const svgTrash = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.12492 8.95833V13.5417M11.0416 8.95833V13.5417M7.29159 6.45833V5.625C7.29159 4.70452 8.03778 3.95833 8.95825 3.95833H10.2083C11.1287 3.95833 11.8749 4.70452 11.8749 5.625V6.45833M3.95825 6.45833H15.2083M5.49255 14.5194L4.79159 6.45833H14.3749L13.674 14.5194C13.5991 15.3806 12.8781 16.0417 12.0136 16.0417H7.15295C6.28843 16.0417 5.56744 15.3806 5.49255 14.5194Z"
      stroke="#F43F5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const svgDownload = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.95825 12.2917V13.5417C3.95825 14.9224 5.07754 16.0417 6.45825 16.0417H13.5416C14.9223 16.0417 16.0416 14.9224 16.0416 13.5417V12.2917M9.99992 11.875V3.95833M9.99992 11.875L7.29159 8.95833M9.99992 11.875L12.7083 8.95833"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const svgRetry = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.04159 7.70833L3.95825 5.83333L6.04159 3.95833"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.95825 5.83333H13.5416C14.9223 5.83333 16.0416 6.95262 16.0416 8.33333V9.375"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9583 16.0417L16.0416 14.1667L13.9583 12.2917"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0416 14.1667H6.45825C5.07754 14.1667 3.95825 13.0474 3.95825 11.6667V10.625"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
